module.exports = __webpack_public_path__ + "static/media/lb.f1d34347.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lb.svg
// module id = 172
// module chunks = 0